import { REGEX_PATTERN } from "core/const/validator.const";

export const Email = [
  {
    type: "email",
    name: "email",
    label: "signup.placeholder.email",
    placeholder: "signup.placeholder.email",
    validation: {
      required: "Email is required",
      pattern: {
        value: REGEX_PATTERN.email,
        message: "Please enter the valid email",
      },
    },
  },
];

export const FirstName = [
  {
    type: "text",
    name: "first_name",
    placeholder: "signup.placeholder.firstname",
    label: "signup.placeholder.firstname",
    validation: { required: "Firstname is required" },
  },
];

export const LastName = [
  {
    type: "text",
    name: "last_name",
    label: "signup.placeholder.surname",
    placeholder: "signup.placeholder.surname",
    validation: { required: "Lastname is required" },
  },
];

export const PasswordField = [
  {
    type: "password",
    name: "password",
    label: "signup.placeholder.create_password",
    placeholder: "signup.placeholder.create_password",
    validation: {
      required: "Password is required",
      pattern: {
        value: REGEX_PATTERN.password,
        message: "Invalid password Format",
      },
    },
  },
];

export const whichRedirectDomains = window.location.href.includes("accounts.")
  ? "https://which.gosimpletax.com"
  : "";
